module.exports = __webpack_public_path__ + "img/Group_3.4ee4fca2.png";